module.exports = __webpack_public_path__ + "static/media/avsloja.a4bfc876.mp3";